/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import React from "react";
import { GiftItemData } from "../../modules/streaming";

import { CommentItemNormal } from "./commentItem/CommentItemNormal";
import { CommentItemSuperChat } from "./commentItem/CommentItemSuperChat";
import { CommentItemPurchasedHiddenName } from "./commentItem/CommentItemPurchasedHiddenName";
import type { ProductData, UserMessage } from "@spwn/types/firebase/firestore";

// Implemented in the future

interface Props {
  eventId: string;
  message: UserMessage;
  isCommentUser: boolean;
  isDarkModeEnabled: boolean;
  giftItemMap: { [key: string]: GiftItemData };
  eventGoodsMap: { [key: string]: ProductData };
  giftAmountList: number[];
  onClickBanUser: (comment: Pick<UserMessage, "_id" | "uid">) => Promise<void>;
  onClickBanComment: (idx: string) => Promise<void>;
  msgDeleteFunction: (idx: string) => void;
}

/**
 * PC表示におけるコメントエリア内のコメント単体
 * @param props
 */
export const StreamingCommentItem: React.FC<Props> = (props) => {
  const { isSuperChat, isPurchased, purchasedProductId } = props.message;
  const purchasedProduct: ProductData = isPurchased
    ? // @ts-expect-error TS2538
      props.eventGoodsMap?.[purchasedProductId]
    : null;

  return (
    <React.Fragment>
      {
        // 普通のコメントの時の表示
        !isSuperChat && !isPurchased && (
          <CommentItemNormal
            eventId={props.eventId}
            message={props.message}
            isCommentUser={props.isCommentUser}
            isDarkModeEnabled={props.isDarkModeEnabled}
            onClickBanUser={props.onClickBanUser}
            onClickBanComment={props.onClickBanComment}
            msgDeleteFunction={props.msgDeleteFunction}
          />
        )
      }

      {
        // スパチャコメントの時の表示
        isSuperChat && !isPurchased && (
          <CommentItemSuperChat
            message={props.message}
            eventId={props.eventId}
            isCommentUser={props.isCommentUser}
            giftItemMap={props.giftItemMap}
            giftAmountList={props.giftAmountList}
            onClickBanUser={props.onClickBanUser}
            onClickBanComment={props.onClickBanComment}
          />
        )
      }

      {
        // 購入した時の表示
        // 名前を表示しない時の表示
        !isSuperChat && isPurchased && (
          // && !isDisplayName
          <CommentItemPurchasedHiddenName purchasedProduct={purchasedProduct} />
        )
      }

      {
        // Implemented in the future
        // 名前を表示する場合の表示
        // !isSuperChat
        //   && isPurchased
        //   && isDisplayName
        //   &&  <CommentItemPurchasedDisplayName
        //         message={props.message}
        //         purchasedProduct={purchasedProduct}
        //       />
      }
    </React.Fragment>
  );
};
